import React from 'react'
import { render } from 'react-dom'
import { Provider } from 'react-redux'
import { Router, Route } from 'react-router'
import { ActionCableProvider } from 'react-actioncable-provider'

import * as CONST from '../commons/Const'
import store, { history } from './store'
import TopPage from './containers/TopPage/TopPage'
import SignupPage from './containers/SignupPage/SignupPage'
import QuizPage from './containers/QuizPage/QuizPage'

import '../commons/css/reset.css'
import RequireAuth from './components/organisms/RequireAuth/RequireAuth'
import RedirectToQuiz from './components/organisms/RedirectToQuiz/RedirectToQuiz'
import ErrorBoundary from './components/organisms/ErrorBoundary/ErrorBoundary'
import DemoPage from './containers/DemoPage/DemoPage'

render(
  <ErrorBoundary>
    <ActionCableProvider url={CONST.SOCKET_URL}>
      <Provider store={store}>
        <Router
          history={history}
          onUpadate={() => {
            window.scrollTo(0, 0)
          }}
        >
          <Route path="/" component={RedirectToQuiz(TopPage)} />
          <Route path="/signup" component={RedirectToQuiz(SignupPage)} />
          <Route path="/quiz" component={RequireAuth(QuizPage)} />
          <Route path="/demo" component={DemoPage} />
        </Router>
      </Provider>
    </ActionCableProvider>
  </ErrorBoundary>,
  document.getElementById('app')
)
